import React from 'react';
import {
  Accordion,
  Panel,
  Section,
  SectionSubTitle,
  Typography,
} from 'common/components';
import { analyticsUtils } from 'utils/analytics-utils';
import {
  CUSTOM_SIZE,
  GUARANTEE,
  HOW_CHOOSE,
  HOW_LONG,
} from './storage-faq-constants';
import {
  questionAccordion,
  questionText,
} from './storage-faq-styles';

export const StorageFaq: React.FC<{ elementBlock: string }> = ({ elementBlock }) => {
  /**
   * Обработчик нажатия на колапс панели
   */

  const handlePanelClick = (question: string, order: number) => (_: string, isOpen: boolean) => {
    if (!isOpen) {
      analyticsUtils.clickButtonEvent(
        elementBlock,
        `${question.slice(0, 100)} / ${order}`,
        'Часто задаваемые вопросы'
      );
    }
  };

  return (
    <Section itemScope itemType="https://schema.org/FAQPage">
      <SectionSubTitle margin="m">Вопрос-ответ</SectionSubTitle>
      <Accordion className={questionAccordion}>
        <Panel name="pricing" onClick={handlePanelClick(HOW_LONG, 1)} title={HOW_LONG}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <div itemProp="text">
              <Typography variant="s" size="body_long" className={questionText}>
                Мы&nbsp;можем доставить товары из&nbsp;наличия в&nbsp;тот&nbsp;же день или на&nbsp;следующий
                день после оплаты.И до&nbsp;7&nbsp;дней от&nbsp;проекта до&nbsp;установки мебели у&nbsp;вас дома при заказе услуги.
              </Typography>
              <Typography variant="s" size="body_long">
                При заказе мебели на&nbsp;заказ сроки рассчитываются индивидуально. Стандартный срок
                производства&nbsp;&mdash; от&nbsp;21&nbsp;дняс момента оплаты
              </Typography>
            </div>
          </div>
        </Panel>

        <Panel name="timing" onClick={handlePanelClick(CUSTOM_SIZE, 2)} title={CUSTOM_SIZE}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" className={questionText} itemProp="text">
              Да, для потребностей сделать мебель в&nbsp;точные размеры клиента мы&nbsp;предлагаем бесплатное проектирование
              мебели на&nbsp;заказ. Уточняйте подробности в&nbsp;магазине вашего города.
            </Typography>
            <Typography variant="s" size="body_long" itemProp="text">
              Мы&nbsp;проектируем и&nbsp;продаем шкафы-купе, двери-купе, гардеробные, прихожие, распашные шкафы и&nbsp;другую мебель
              по&nbsp;индивидуальным размерам со&nbsp;сроком производства от&nbsp;21&nbsp;дня
            </Typography>
          </div>
        </Panel>

        <Panel name="always" onClick={handlePanelClick(GUARANTEE, 3)} title={GUARANTEE}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Мы&nbsp;используем ЛДСП/МДФ от&nbsp;проверенных поставщиков. Все материалы сертифицированы. Сертификаты
              доступны в&nbsp;карточке товара или по&nbsp;запросу в&nbsp;магазине
            </Typography>
          </div>
        </Panel>

        <Panel name="moreGoods" onClick={handlePanelClick(HOW_CHOOSE, 4)} title={HOW_CHOOSE}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Ориентируйтесь на&nbsp;качественную фурнитуру , толщину фасадов (от&nbsp;16&nbsp;мм) и&nbsp;отзывы клиентов.
              Рекомендуем посетить отдел Хранение в&nbsp;магазине Лемана Про и&nbsp;спроектировать мебель со&nbsp;специалистом
              или использовать 3D-конфигуратор на&nbsp;сайте.
            </Typography>
          </div>
        </Panel>
      </Accordion>
    </Section>
  );
};
